import React from "react";
import ContentLoader from "react-content-loader";

const LoadingSkeleton = ({ loading, children, className }) => {
  return loading ? (
    <ContentLoader
      // viewBox={`0 0 ${width} ${height}`}
      speed={1}
      className={`${className}`}
      backgroundColor="#ffffff"
      foregroundColor="#e5e7eb"
    >
      <rect x="0" y="10" rx="5" ry="5" width="100" height="20" />
      <rect x="0" y="40" rx="5" ry="5" width="80%" height="10" />
      <rect x="0" y="40" rx="5" ry="5" width="80%" height="10" />
      <rect x="0" y="60" rx="5" ry="5" width="60%" height="10" />
    </ContentLoader>
  ) : (
    children
  );
};

export default LoadingSkeleton;
